
import { mapMutations } from 'vuex';
import AddToCartBtn from '~/components/widgets/AddToCardBtn/AddToCardBtn.vue';
import AddBuyOneClickBtn from '~/components/widgets/AddBuyOneClickBtn/AddBuyOneClickBtn.vue';
// import PromotionLabel from '~/components/common/PromotionLabel.vue';

export default {
  name: 'ProductCard',
  components: {
    AddToCartBtn,
    AddBuyOneClickBtn,
    // PromotionLabel,
  },
  props: {
    product: {
      type: Object,
      default() {
        return {};
      },
    },
    imageId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    productCardName() {
      return `${this.product?.name} ${this?.product?.code || ''}` || '';
    },
    isShowCode() {
      return this.products?.characteristics?.[0]?.characteristics.some((t) => t.name === 'Артикул' && t.showInProductCard);
    },
    setImageId() {
      return this.product?.imageId || this.product?.image_id || this.product?.main_photo_id;
    },
    shortCharacteristics() {
      const character = [];
      if (this.product.shortCharacteristics) {
        this.product.shortCharacteristics.forEach((char) => {
          const newString = [];

          char.values.forEach((t) => {
            newString.push(t.value);
          });

          character.push({ name: char.name, value: newString });
        });
      }
      return character;
    },
    currentCity() {
      return this.$store?.state?.appState?.config?.city?.data?.prepositional || 'Екатеринбурге';
    },
    productCardNameForSeo() {
      return `${this.productCardName} в ${this.currentCity}`;
    },
  },
  methods: {},
  emits: ['put-to-cart', 'open-consultation-modal'],

};
